import PageBackTitle from "../Component/PageBackTitle";
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import API_URL from "../../src/Config";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { setHours, setMinutes } from "date-fns";
// import Chip from "@mui/material/Chip";
// import Stack from "@mui/material/Stack";
// import "./Form.css";

// function Form1({
//   isSidebarExpanded,
//   permit_id,
//   permit_type_id,
//   fetchComplitionSatusData,
// }) {
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const { id } = useParams();
//   const [severity, setSeverity] = useState("success");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const navigate = useNavigate();
//   const [departments, setDepartments] = useState([]);
//   const [permitType, setPermitType] = useState([]);
//   const [selectedPermitType, setSelectedPermitType] = useState(null);
//   const [tagOptions, setTagOptions] = useState([]);
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [reason, setReason] = useState("");
//   const [workPermitName, setWorkPermitName] = useState("");
//   const [workPermitId, setWorkPermitId] = useState("");
//   const [equipmentDetails, setEquipmentDetails] = useState([]);
//   const [work_id, setWork_id] = useState("");
//   const [dateValues, setDateValues] = useState({});
//   const [dynamicSubFields, setDynamicSubFields] = useState([]);
//   const [fields, setFields] = useState([]);
//   const [dynamicApiEndpoint, setDynamicApiEndpoint] = useState("");
//   const [selectedOptions, setSelectedOptions] = useState({});
//   const [dropdownOptions, setDropdownOptions] = useState({});
//   const [isDataLoaded, setIsDataLoaded] = useState(false);

//   const [formData, setFormData] = useState({
//     section: "",
//     department_id: "",
//     form_id: "",
//     area: "",
//     equipment_no: "",
//     issued_to: "",
//     work_description: "",
//     contractor: "",
//     unit: "",
//     location: "",
//     facility_location: "",
//     work_location: "",
//     valid_from: "",
//     valid_to: "",
//     receiver_name: "",
//     permit_type_id: "",
//     permit_id: "",
//     department: "",
//     no_of_men: "",
//     excavation_depth: "",
//     excavation_length: "",
//     excavation_width: "",
//     work_type_list: [],
//     work_type: "",
//     performing_agency: "",
//     related_permit_no: "",
//     work_time_from: "",
//     work_time_to: "",
//   });

//   // ============================================
//   // FULLY DYNAMIC VALIDATION FUNCTION
//   // ============================================
//   const validateRequiredFields = () => {
//     const errors = {};

//     // 1. Validate permit type selection (always required)
//     if (!selectedPermitType?.value && !formData.permit_type_id) {
//       errors.selectedPermitType = "Permit Type is required";
//     }

//     // 2. Validate dynamic fields from permit type configuration
//     fields.forEach((field) => {
//       if (Number(field.is_required) === 1) {
//         const fieldName = field.field_name;
//         const fieldLabel = field.field_label;

//         if (field.field_type === "dropdown") {
//           if (field.is_multiple) {
//             // Multi-select dropdown validation
//             if (!selectedOptions[field.id]?.length) {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           } else {
//             // Single-select dropdown validation
//             const hasValueInFormData =
//               formData[fieldName] && formData[fieldName] !== "";
//             const hasValueInSelectedOptions = selectedOptions[field.id]?.value;

//             if (!hasValueInFormData && !hasValueInSelectedOptions) {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           }
//         } else if (field.field_type === "date") {
//           if (!dateValues[fieldLabel]) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else if (field.field_type === "checkbox") {
//           const checkboxValues = formData[fieldName];
//           if (
//             !checkboxValues ||
//             (Array.isArray(checkboxValues) && checkboxValues.length === 0)
//           ) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else {
//           // Text, number, textarea validation
//           const value = formData[fieldName];
//           if (!value || (typeof value === "string" && !value.trim())) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         }
//       }
//     });

//     // 3. Validate dynamic sub-fields
//     dynamicSubFields.forEach((subField) => {
//       if (Number(subField.is_required) === 1) {
//         const fieldName = subField.field_name;
//         const fieldLabel = subField.field_label;

//         if (subField.field_type === "dropdown") {
//           if (fieldName === "department_name") {
//             if (!formData.department_id || formData.department_id === "") {
//               errors.department_id = `${fieldLabel} is required`;
//             }
//           } else {
//             if (!formData[fieldName] || formData[fieldName] === "") {
//               errors[fieldName] = `${fieldLabel} is required`;
//             }
//           }
//         } else if (subField.field_type === "date") {
//           if (!dateValues[fieldLabel]) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else if (subField.field_type === "checkbox") {
//           const checkboxValues = formData[fieldName];
//           if (
//             !checkboxValues ||
//             (Array.isArray(checkboxValues) && checkboxValues.length === 0)
//           ) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         } else {
//           const value = formData[fieldName];
//           if (!value || (typeof value === "string" && !value.trim())) {
//             errors[fieldName] = `${fieldLabel} is required`;
//           }
//         }
//       }
//     });

//     // 4. Validate date range
//     const startDateField = fields.find(
//       (f) => f.field_label === "Start Date & Time"
//     );
//     const endDateField = fields.find(
//       (f) => f.field_label === "End Date & Time"
//     );

//     if (startDateField && endDateField) {
//       const startDate = dateValues[startDateField.field_label];
//       const endDate = dateValues[endDateField.field_label];

//       if (startDate && endDate && startDate >= endDate) {
//         errors[endDateField.field_name] = "End date must be after start date";
//       }
//     }

//     // 5. Validate work time range if applicable
//     const workTimeFromField = fields.find(
//       (f) => f.field_label === "Work Time From"
//     );
//     const workTimeToField = fields.find(
//       (f) => f.field_label === "Work Time To"
//     );

//     if (workTimeFromField && workTimeToField) {
//       const workTimeFrom = dateValues[workTimeFromField.field_label];
//       const workTimeTo = dateValues[workTimeToField.field_label];

//       if (workTimeFrom && workTimeTo && workTimeFrom >= workTimeTo) {
//         errors[workTimeToField.field_name] =
//           "Work time to must be after work time from";
//       }
//     }

//     console.log("=== VALIDATION DEBUG (FORM1) ===");
//     console.log("Validation Errors:", errors);
//     console.log("FormData:", formData);
//     console.log("DateValues:", dateValues);
//     console.log("SelectedOptions:", selectedOptions);
//     console.log("================================");

//     return errors;
//   };

//   // ============================================
//   // FULLY DYNAMIC PAYLOAD BUILDER
//   // ============================================
//   const buildDynamicPayload = () => {
//     const payload = {
//       permit_type_id: formData.permit_type_id,
//       work_id: work_id || "",
//     };

//     // Process all dynamic fields
//     fields.forEach((field) => {
//       const fieldName = field.field_name;
//       const fieldLabel = field.field_label;

//       switch (field.field_type) {
//         case "dropdown":
//           if (field.is_multiple) {
//             payload[fieldName] = selectedOptions[field.id]
//               ? selectedOptions[field.id].map((item) => item.value)
//               : [];
//           } else {
//             if (formData[fieldName]) {
//               payload[fieldName] = formData[fieldName];
//             } else if (selectedOptions[field.id]) {
//               payload[fieldName] = selectedOptions[field.id].value;
//             } else {
//               payload[fieldName] = "";
//             }
//           }
//           break;

//         case "date":
//           if (dateValues[fieldLabel]) {
//             const dt = new Date(dateValues[fieldLabel]);
//             payload[fieldName] = `${dt.getFullYear()}-${String(
//               dt.getMonth() + 1
//             ).padStart(2, "0")}-${String(dt.getDate()).padStart(
//               2,
//               "0"
//             )} ${String(dt.getHours()).padStart(2, "0")}:${String(
//               dt.getMinutes()
//             ).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
//           } else {
//             payload[fieldName] = null;
//           }
//           break;

//         case "checkbox":
//           const checkboxValues = formData[fieldName];
//           if (Array.isArray(checkboxValues)) {
//             payload[fieldName] = checkboxValues;
//           } else if (checkboxValues) {
//             payload[fieldName] = [checkboxValues];
//           } else {
//             payload[fieldName] = [];
//           }
//           break;

//         case "number":
//           const numValue = formData[fieldName];
//           payload[fieldName] =
//             numValue && numValue !== "" ? Number(numValue) : null;
//           break;

//         default:
//           const textValue = formData[fieldName];
//           payload[fieldName] =
//             textValue && typeof textValue === "string"
//               ? textValue.trim()
//               : textValue || "";
//       }
//     });

//     // Process dynamic sub-fields
//     dynamicSubFields.forEach((subField) => {
//       const fieldName = subField.field_name;
//       const fieldLabel = subField.field_label;

//       switch (subField.field_type) {
//         case "dropdown":
//           if (fieldName === "department_name") {
//             payload["department_id"] = formData.department_id || "";
//           } else {
//             payload[fieldName] = formData[fieldName] || "";
//           }
//           break;

//         case "date":
//           if (dateValues[fieldLabel]) {
//             const dt = new Date(dateValues[fieldLabel]);
//             payload[fieldName] = `${dt.getFullYear()}-${String(
//               dt.getMonth() + 1
//             ).padStart(2, "0")}-${String(dt.getDate()).padStart(
//               2,
//               "0"
//             )} ${String(dt.getHours()).padStart(2, "0")}:${String(
//               dt.getMinutes()
//             ).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
//           } else {
//             payload[fieldName] = null;
//           }
//           break;

//         case "checkbox":
//           const checkboxValues = formData[fieldName];
//           if (Array.isArray(checkboxValues)) {
//             payload[fieldName] = checkboxValues;
//           } else if (checkboxValues) {
//             payload[fieldName] = [checkboxValues];
//           } else {
//             payload[fieldName] = [];
//           }
//           break;

//         case "number":
//           const numValue = formData[fieldName];
//           payload[fieldName] =
//             numValue && numValue !== "" ? Number(numValue) : null;
//           break;

//         default:
//           const textValue = formData[fieldName];
//           payload[fieldName] =
//             textValue && typeof textValue === "string"
//               ? textValue.trim()
//               : textValue || "";
//       }
//     });

//     return payload;
//   };

//   // ============================================
//   // SAVE HANDLER WITH DYNAMIC PAYLOAD
//   // ============================================
//   const handleSaveClick = async () => {
//     try {
//       setErrors({});

//       const validationErrors = validateRequiredFields();

//       if (Object.keys(validationErrors).length > 0) {
//         setErrors(validationErrors);
//         setSeverity("error");
//         showSnackbar("Please fill all required fields");

//         const firstErrorField = Object.keys(validationErrors)[0];
//         const errorElement = document.querySelector(
//           `[name="${firstErrorField}"]`
//         );
//         if (errorElement) {
//           errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
//         }

//         return;
//       }

//       const payload = buildDynamicPayload();

//       console.log("=== FORM1 PAYLOAD ===");
//       console.log(JSON.stringify(payload, null, 2));
//       console.log("====================");

//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");

//       const response = await axios.put(
//         `${API_URL}/api/update_permit_work_details`,
//         payload,
//         {
//           headers: {
//             Authorization: authKey,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 200) {
//         setSeverity("success");
//         showSnackbar("Permit details updated successfully.");
//         {
//           permit_type_id === "e32d9e81-a68c-11f0-81e8-9c2dcdaf01ba"
//             ? setTimeout(() => {
//                 navigate(
//                   `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Departments`
//                 );
//               }, 1000)
//             : setTimeout(() => {
//                 navigate(
//                   `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Checklist Items`
//                 );
//               }, 1000);
//         }
//       } else {
//         throw new Error(
//           response.data.message || "Failed to update permit details."
//         );
//       }
//     } catch (error) {
//       console.error("Error saving permit details:", error);
//       setSeverity("error");

//       const errorMessage =
//         error.response?.data?.message ||
//         error.message ||
//         "An error occurred while saving permit details.";

//       showSnackbar(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleReasonChange = (e) => {
//     setReason(e.target.value);
//   };

//   const closePopup = () => {
//     setIsPopupOpen(false);
//   };

//   const handleSaveRejectClick = async () => {
//     const payload = {
//       permit_id: permit_id,
//       request_type: "New",
//       reason: reason,
//     };

//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       if (!authKey) {
//         throw new Error("Authorization key not found");
//       }

//       const response = await axios.post(
//         `${API_URL}/api/reject_permit`,
//         payload,
//         {
//           headers: { Authorization: authKey },
//         }
//       );

//       if (response.status === 200) {
//         setSeverity("success");
//         showSnackbar("Permit rejected successfully.");
//         closePopup();
//       } else {
//         throw new Error(response.data.message || "Failed to reject permit.");
//       }
//     } catch (error) {
//       console.error("Error rejecting permit:", error);
//       setSeverity("error");
//       showSnackbar(
//         error.response?.data?.message ||
//           "An error occurred while rejecting the permit."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancelClick = () => {
//     navigate("/cold-work-permit");
//   };

//   const handleRejectClick = () => {
//     setIsPopupOpen(true);
//   };

//   const showSnackbar = (message) => {
//     setSnackbarMessage(message);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const clearFieldError = (fieldName) => {
//     if (errors[fieldName] || errors.department_id) {
//       setErrors((prevErrors) => {
//         const newErrors = { ...prevErrors };
//         delete newErrors[fieldName];

//         if (fieldName === "department_name" && newErrors.department_id) {
//           delete newErrors.department_id;
//         }

//         return newErrors;
//       });
//     }
//   };

//   // Fetch departments
//   const fetchDepartment = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_departments`, {
//         headers: { Authorization: authKey },
//       });

//       const options = response.data.map((department) => ({
//         label: department.DepartmentName,
//         value: department.ID,
//       }));
//       setDepartments(options);
//     } catch (error) {
//       console.error("Error fetching departments:", error);
//     }
//   };

//   // Fetch tag options
//   const fetchOptions = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_equipment_tag_no`, {
//         headers: {
//           Authorization: authKey,
//         },
//       });

//       const optionsData = response.data.Items.map((item) => ({
//         value: item.ID,
//         label: `${item.TagNo}`,
//       }));

//       setTagOptions(optionsData);
//       if (optionsData.length === 0) {
//         console.warn("No options available from API");
//       }
//     } catch (error) {
//       console.error("Error fetching options:", error);
//     }
//   };

//   // Fetch permit types
//   const fetchPermitType = async () => {
//     try {
//       const authKey = localStorage.getItem("authKey");
//       const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
//         headers: {
//           Authorization: authKey,
//         },
//       });

//       const permitTypeOptions = response.data.work_permit_types.map(
//         (permitType) => ({
//           value: permitType.id,
//           label: permitType.work_permit_name,
//         })
//       );

//       setPermitType(permitTypeOptions);
//     } catch (error) {
//       console.error("Error fetching permit types:", error);
//     }
//   };

//   // Handle permit type change
//   const handlePermitTypeChange = async (selectedOption) => {
//     console.log("selectedOption", selectedOption);
//     setSelectedPermitType(selectedOption);

//     if (selectedOption) {
//       try {
//         const authKey = localStorage.getItem("authKey");

//         const response = await axios.get(
//           `${API_URL}/api/get_permit_fields/${selectedOption.value}`,
//           { headers: { Authorization: authKey } }
//         );

//         if (response.status === 200) {
//           const fetchedFields = response.data.fields;
//           setFields(fetchedFields);
//           console.log("Fields loaded:", fetchedFields);

//           const dropdownFields = fetchedFields.filter(
//             (field) => field.field_type === "dropdown" && field.api_endpoint
//           );

//           const optionsData = {};
//           await Promise.all(
//             dropdownFields.map(async (field) => {
//               try {
//                 const dropdownResponse = await axios.get(
//                   `${API_URL}/${field.api_endpoint}`,
//                   { headers: { Authorization: authKey } }
//                 );

//                 const responseData = dropdownResponse.data;
//                 optionsData[field.id] = Array.isArray(responseData)
//                   ? responseData.map((item) => ({
//                       value: item.ID,
//                       label:
//                         item.DepartmentName ||
//                         item.TagNo ||
//                         item.Category ||
//                         "Unknown",
//                     }))
//                   : responseData.Items?.map((item) => ({
//                       value: item.ID,
//                       label: item.TagNo || item.Category || "Unknown",
//                     })) || [];
//               } catch (error) {
//                 console.error(
//                   `Error fetching options for ${field.field_label}:`,
//                   error
//                 );
//               }
//             })
//           );

//           setDropdownOptions(optionsData);
//           console.log("Dropdown options loaded:", optionsData);
//         }

//         // Fetch the dynamic endpoint
//         const endpointResponse = await axios.get(
//           `${API_URL}/api/get_permit_api_endpoints/${selectedOption.value}`,
//           { headers: { Authorization: authKey } }
//         );

//         if (
//           endpointResponse.status === 200 &&
//           endpointResponse.data.endpoints.length > 0
//         ) {
//           const postEndpoint = endpointResponse.data.endpoints.find(
//             (e) => e.method === "POST"
//           );
//           if (postEndpoint) {
//             setDynamicApiEndpoint(postEndpoint.api_endpoint);
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching permit fields:", error);
//       }
//     }
//   };

//   // Load permit details
//   useEffect(() => {
//     const getPermitDetails = async () => {
//       try {
//         const authKey = localStorage.getItem("authKey");
//         const response = await axios.get(
//           `${API_URL}/api/get_permit_work_details/${permit_id}`,
//           { headers: { Authorization: authKey } }
//         );

//         const permit = response.data.permit_details[0];
//         console.log("Loaded permit details:", permit);

//         setWorkPermitName(permit?.work_permit_name);
//         setWorkPermitId(permit?.permit_type_id);
//         setWork_id(permit?.work_id);
//         setEquipmentDetails(permit?.equipment_details || []);

//         // Build dependent field values
//         const dependentFieldValues = {};
//         const dependentFieldsFromPermit =
//           permit.issued_to?.dependent_fields || [];

//         dependentFieldsFromPermit.forEach((dep) => {
//           dependentFieldValues[dep.field_name] = dep.value;
//         });

//         setDynamicSubFields(
//           dependentFieldsFromPermit.map((dep) => ({
//             id: dep.field_name,
//             field_name: dep.field_name,
//             field_label: dep.field_label,
//             field_type: dep.field_type,
//             placeholder: "",
//             is_required: dep.is_required || 0,
//           }))
//         );

//         // Populate form data with all fields from API
//         setFormData((prev) => ({
//           ...prev,
//           permit_type_id: permit.permit_type_id,
//           issued_to: permit.issued_to?.value || "",
//           ...dependentFieldValues,
//           department: permit.department_name,
//           department_id: permit?.department_id || "",
//           receiver_name: permit.receiver_name,
//           area: permit.area || "",
//           unit: permit.unit || "",
//           section: permit?.section || "",
//           // location: permit?.location || "",
//           location: permit?.facility_location || "",
//           facility_location: permit?.facility_location || "",
//           work_location: permit?.work_location || "",
//           work_description: permit.work_description || "",
//           contractor: permit?.contractor || "",
//           no_of_men: permit.no_of_men || "",
//           excavation_depth: permit.excavation_depth || "",
//           excavation_length: permit.excavation_length || "",
//           excavation_width: permit.excavation_width || "",
//           work_type_list: permit.work_type_list || [],
//           work_type: permit.work_type || "",
//           performing_agency: permit.performing_agency || "",
//           related_permit_no: permit.related_permit_no || "",
//         }));

//         // Format and set dates
//         const formatDate = (dateString) => {
//           if (!dateString) return null;
//           const date = new Date(dateString);
//           date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
//           return date;
//         };

//         setDateValues({
//           "Start Date & Time": formatDate(permit.valid_from),
//           "End Date & Time": formatDate(permit.valid_to),
//           "Work Start (From Date & Time)": formatDate(permit.work_time_from),
//           "Work End (To Date & Time)": formatDate(permit.work_time_to),
//         });

//         setIsDataLoaded(true);
//       } catch (error) {
//         console.error("Failed to load permit details", error);
//         setSeverity("error");
//         showSnackbar("Failed to load permit details");
//       }
//     };

//     if (permit_id) {
//       getPermitDetails();
//     }
//   }, [permit_id]);

//   // Map equipment details to selected options
//   useEffect(() => {
//     if (fields?.length && equipmentDetails?.length && isDataLoaded) {
//       const equipmentField = fields.find(
//         (f) => f.field_name === "equipment_ids"
//       );

//       if (equipmentField) {
//         const selectedEquipment = equipmentDetails.map((eq) => ({
//           value: eq.equipment_id,
//           label: eq.TagNo || eq.equipment_no || "",
//         }));

//         setSelectedOptions((prev) => ({
//           ...prev,
//           [equipmentField.id]: selectedEquipment,
//         }));

//         if (!dropdownOptions[equipmentField.id]) {
//           setDropdownOptions((prev) => ({
//             ...prev,
//             [equipmentField.id]: selectedEquipment,
//           }));
//         }
//       }
//     }
//   }, [fields, equipmentDetails, isDataLoaded]);

//   // Initialize permit type fields
//   useEffect(() => {
//     if (formData.permit_type_id && workPermitId) {
//       const selectedOption = {
//         value: workPermitId,
//         label: workPermitName,
//       };
//       handlePermitTypeChange(selectedOption);
//     }
//   }, [formData.permit_type_id, workPermitId]);

//   // Initialize on mount
//   useEffect(() => {
//     fetchDepartment();
//     fetchPermitType();
//     fetchOptions();
//   }, []);

//   return (
//     <>
//       <div className="data-form-content">
//         <div className="data-form-header">
//           <div className="data-form-header-content">
//             <PageBackTitle className="data-form-heading-content-left-side">//               Work Permit Request
//</PageBackTitle>
//             <div className="data-form-heading-content-right-side"></div>
//           </div>
//         </div>
//         <div className="header-separator"></div>
//         <div className="data-form-body">
//           <form className="form-detail">
//             <div className="new-data-form">
//               {/* Permit Type Selection */}
//               <div className="form-group-select">
//                 <label htmlFor="form_type">
//                   Permit Type<span className="text-danger">*</span>
//                 </label>
//                 <Select
//                   id="form_type"
//                   options={permitType}
//                   value={permitType.find(
//                     (option) => option.value === formData.permit_type_id
//                   )}
//                   onChange={handlePermitTypeChange}
//                   placeholder="Select permit type"
//                   isDisabled={true}
//                 />
//                 {errors.selectedPermitType && (
//                   <div className="error-message">
//                     {errors.selectedPermitType}
//                   </div>
//                 )}
//               </div>

//               {/* Dynamic Fields Container */}
//               <div className="permit-fields-container">
//                 {fields?.length > 0 &&
//                   fields.map((field) => {
//                     const isIssuedToField = field.field_name === "issued_to";

//                     return (
//                       <div key={field.id} className="form-group">
//                         <label>
//                           {field.field_label}
//                           {Number(field.is_required) === 1 && (
//                             <span className="text-danger">*</span>
//                           )}
//                         </label>

//                         {isIssuedToField ? (
//                           <div className="wp-dflex-div">
//                             <div className="">
//                               <Select
//                                 className="full-width-select-wp"
//                                 options={field.options.map((opt) => ({
//                                   label: opt,
//                                   value: opt,
//                                 }))}
//                                 value={
//                                   formData.issued_to
//                                     ? {
//                                         value: formData.issued_to,
//                                         label: formData.issued_to,
//                                       }
//                                     : null
//                                 }
//                                 onChange={async (selected) => {
//                                   const value = selected ? selected.value : "";

//                                   setFormData((prev) => ({
//                                     ...prev,
//                                     issued_to: value,
//                                     department_id: "",
//                                   }));

//                                   setErrors((prevErrors) => {
//                                     const newErrors = { ...prevErrors };
//                                     delete newErrors[field.field_name];
//                                     delete newErrors.issued_to;
//                                     return newErrors;
//                                   });

//                                   if (value) {
//                                     try {
//                                       const authKey =
//                                         localStorage.getItem("authKey");
//                                       const response = await axios.get(
//                                         `${API_URL}/api/dependent_fields`,
//                                         {
//                                           headers: { Authorization: authKey },
//                                           params: {
//                                             permit_type_id:
//                                               formData.permit_type_id,
//                                             controller_field_id: field.id,
//                                             controller_value: value,
//                                           },
//                                         }
//                                       );

//                                       let fetchedSubFields =
//                                         response.data.fields || [];

//                                       for (const subField of fetchedSubFields) {
//                                         if (
//                                           subField.options_source === "api" &&
//                                           subField.api_endpoint
//                                         ) {
//                                           const subOptionsRes = await axios.get(
//                                             `${API_URL}/${subField.api_endpoint}`,
//                                             {
//                                               headers: {
//                                                 Authorization: authKey,
//                                               },
//                                             }
//                                           );
//                                           subField.options =
//                                             subOptionsRes.data || [];
//                                         }
//                                       }

//                                       setDynamicSubFields(fetchedSubFields);
//                                     } catch (error) {
//                                       console.error(
//                                         "Error fetching dependent fields:",
//                                         error
//                                       );
//                                       setDynamicSubFields([]);
//                                     }
//                                   } else {
//                                     setDynamicSubFields([]);
//                                   }
//                                 }}
//                                 placeholder="Select issued to"
//                                 isClearable
//                               />
//                             </div>

//                             <div style={{ marginBottom: "0px" }}>
//                               {dynamicSubFields.map((subField) => (
//                                 <div
//                                   key={subField.id}
//                                   className={
//                                     subField.field_type === "dropdown"
//                                       ? "form-group-select"
//                                       : "form-group"
//                                   }
//                                 >
//                                   <label>
//                                     {subField.field_label}
//                                     {Number(subField.is_required) === 1 && (
//                                       <span className="text-danger">*</span>
//                                     )}
//                                   </label>

//                                   {subField.field_type === "dropdown" && (
//                                     <Select
//                                       className="full-width-select-wp"
//                                       options={(subField.options?.length > 0
//                                         ? subField.options
//                                         : departments
//                                       ).map((opt) => ({
//                                         value: opt?.ID || opt?.value,
//                                         label:
//                                           opt?.DepartmentName ||
//                                           opt?.Name ||
//                                           opt?.label ||
//                                           "",
//                                       }))}
//                                       value={(() => {
//                                         const isDepartmentField =
//                                           subField.field_name ===
//                                           "department_name";
//                                         const storedValue = isDepartmentField
//                                           ? formData.department_id
//                                           : formData[subField.field_name];

//                                         return storedValue
//                                           ? {
//                                               value: storedValue,
//                                               label:
//                                                 formData[
//                                                   subField.field_label
//                                                 ] ||
//                                                 formData.department ||
//                                                 "",
//                                             }
//                                           : null;
//                                       })()}
//                                       onChange={(selected) => {
//                                         const selectedId =
//                                           selected?.value || "";
//                                         const selectedLabel =
//                                           selected?.label || "";

//                                         setFormData((prev) => {
//                                           const updates = {
//                                             ...prev,
//                                             [subField.field_label]:
//                                               selectedLabel,
//                                             [subField.field_name]: selectedId,
//                                           };

//                                           if (
//                                             subField.field_name ===
//                                             "department_name"
//                                           ) {
//                                             updates.department_id = selectedId;
//                                             updates.department = selectedLabel;
//                                           }

//                                           return updates;
//                                         });

//                                         setErrors((prevErrors) => {
//                                           const newErrors = { ...prevErrors };
//                                           delete newErrors[subField.field_name];

//                                           if (
//                                             subField.field_name ===
//                                             "department_name"
//                                           ) {
//                                             delete newErrors.department_id;
//                                           }

//                                           return newErrors;
//                                         });
//                                       }}
//                                       placeholder={
//                                         subField.placeholder ||
//                                         `Select ${subField.field_label}`
//                                       }
//                                       isClearable
//                                     />
//                                   )}

//                                   {subField.field_type === "text" && (
//                                     <div className="input-group full-width-input-wp">
//                                       <input
//                                         className="full-width-input-wp"
//                                         type="text"
//                                         name={subField.field_name}
//                                         value={
//                                           formData[subField.field_name] || ""
//                                         }
//                                         onChange={(e) => {
//                                           setFormData((prev) => ({
//                                             ...prev,
//                                             [subField.field_name]:
//                                               e.target.value,
//                                           }));
//                                           clearFieldError(subField.field_name);
//                                         }}
//                                         placeholder={subField.placeholder || ""}
//                                       />
//                                     </div>
//                                   )}

//                                   {(errors[subField.field_name] ||
//                                     (subField.field_name ===
//                                       "department_name" &&
//                                       errors.department_id)) && (
//                                     <div className="error-message">
//                                       {errors[subField.field_name] ||
//                                         errors.department_id}
//                                     </div>
//                                   )}
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         ) : (
//                           <>
//                             {/* Dropdown field */}
//                             {field.field_type === "dropdown" && (
//                               <div className="input-group form-group-tag-no">
//                                 <Select
//                                   id={field.field_label}
//                                   isMulti={field.is_multiple}
//                                   options={
//                                     field.options_source === "api"
//                                       ? dropdownOptions[field.id] || []
//                                       : field.options.map((opt) => ({
//                                           value: opt,
//                                           label: opt,
//                                         }))
//                                   }
//                                   value={
//                                     selectedOptions[field.id] ||
//                                     (field.is_multiple ? [] : null)
//                                   }
//                                   onMenuOpen={async () => {
//                                     if (
//                                       field.options_source === "api" &&
//                                       !dropdownOptions[field.id]
//                                     ) {
//                                       try {
//                                         const authKey =
//                                           localStorage.getItem("authKey");
//                                         const response = await axios.get(
//                                           `${API_URL}/${field.api_endpoint}`,
//                                           {
//                                             headers: {
//                                               Authorization: authKey,
//                                             },
//                                           }
//                                         );
//                                         const fetchedOptions =
//                                           response.data.options || [];
//                                         setDropdownOptions((prev) => ({
//                                           ...prev,
//                                           [field.id]: fetchedOptions.map(
//                                             (opt) => ({
//                                               value: opt,
//                                               label: opt,
//                                             })
//                                           ),
//                                         }));
//                                       } catch (err) {
//                                         console.error(
//                                           "Failed to load dynamic options:",
//                                           err
//                                         );
//                                       }
//                                     }
//                                   }}
//                                   onChange={(selected) => {
//                                     setSelectedOptions((prev) => ({
//                                       ...prev,
//                                       [field.id]: selected,
//                                     }));

//                                     clearFieldError(field.field_name);

//                                     if (field.field_name === "equipment_ids") {
//                                       setFormData((prev) => ({
//                                         ...prev,
//                                         equipment_ids: selected
//                                           ? selected.map((tag) => tag.value)
//                                           : [],
//                                       }));
//                                     }
//                                   }}
//                                   isSearchable
//                                   isClearable={!field.is_multiple}
//                                   placeholder={
//                                     field.placeholder || "Select option"
//                                   }
//                                   styles={{
//                                     container: (base) => ({
//                                       ...base,
//                                       width: "100%",
//                                     }),
//                                   }}
//                                 />
//                                 {field.is_multiple &&
//                                   selectedOptions[field.id]?.length > 0 && (
//                                     <Stack
//                                       direction="row"
//                                       spacing={1}
//                                       flexWrap="wrap"
//                                       sx={{ mt: 1 }}
//                                       className="chip-wrapper"
//                                     >
//                                       {selectedOptions[field.id].map((tag) => (
//                                         <Chip
//                                           key={tag.value}
//                                           label={tag.label}
//                                           onDelete={() => {
//                                             const updated = selectedOptions[
//                                               field.id
//                                             ].filter(
//                                               (item) => item.value !== tag.value
//                                             );
//                                             setSelectedOptions((prev) => ({
//                                               ...prev,
//                                               [field.id]: updated,
//                                             }));

//                                             if (
//                                               field.field_name ===
//                                               "equipment_ids"
//                                             ) {
//                                               setFormData((prev) => ({
//                                                 ...prev,
//                                                 equipment_ids: updated.map(
//                                                   (item) => item.value
//                                                 ),
//                                               }));
//                                             }
//                                           }}
//                                           color="primary"
//                                           variant="outlined"
//                                           sx={{ mb: 1 }}
//                                         />
//                                       ))}
//                                     </Stack>
//                                   )}
//                               </div>
//                             )}

//                             {/* Text field */}
//                             {field.field_type === "text" && (
//                               <div className="input-group">
//                                 <input
//                                   type="text"
//                                   name={field.field_name}
//                                   className="form-control"
//                                   value={formData[field.field_name] || ""}
//                                   required={field.is_required}
//                                   placeholder={field.placeholder}
//                                   onChange={(e) => {
//                                     setFormData((prev) => ({
//                                       ...prev,
//                                       [field.field_name]: e.target.value,
//                                     }));
//                                     clearFieldError(field.field_name);
//                                   }}
//                                 />
//                               </div>
//                             )}

//                             {/* Checkbox field */}
//                             {field.field_type === "checkbox" && (
//                               <div className="permit_checkbox_group">
//                                 {[
//                                   "Excavation",
//                                   "Road Cutting",
//                                   "Road Closure",
//                                 ].map((option) => (
//                                   <label
//                                     key={option}
//                                     className="permit_checkbox-item"
//                                   >
//                                     <div className="checkbox_input">
//                                       <input
//                                         type="checkbox"
//                                         name={field.field_name}
//                                         value={option}
//                                         className="permit_small-checkbox"
//                                         checked={
//                                           formData[field.field_name]?.includes(
//                                             option
//                                           ) || false
//                                         }
//                                         required={
//                                           Number(field.is_required) === 1
//                                         }
//                                         onChange={(e) => {
//                                           const checked = e.target.checked;
//                                           setFormData((prev) => {
//                                             const currentValues =
//                                               prev[field.field_name] || [];
//                                             return {
//                                               ...prev,
//                                               [field.field_name]: checked
//                                                 ? [...currentValues, option]
//                                                 : currentValues.filter(
//                                                     (val) => val !== option
//                                                   ),
//                                             };
//                                           });
//                                           clearFieldError(field.field_name);
//                                         }}
//                                       />
//                                     </div>
//                                     <div className="checkbox_option">
//                                       {option}
//                                     </div>
//                                   </label>
//                                 ))}
//                               </div>
//                             )}

//                             {/* Number field */}
//                             {field.field_type === "number" && (
//                               <div className="input-group">
//                                 <input
//                                   type="number"
//                                   name={field.field_name}
//                                   className="form-control"
//                                   value={formData[field.field_name] || ""}
//                                   required={field.is_required}
//                                   placeholder={field.placeholder}
//                                   onChange={(e) => {
//                                     setFormData((prev) => ({
//                                       ...prev,
//                                       [field.field_name]: e.target.value,
//                                     }));
//                                     clearFieldError(field.field_name);
//                                   }}
//                                 />
//                               </div>
//                             )}

//                             {/* Textarea field */}
//                             {field.field_type === "textarea" && (
//                               <div className="input-group">
//                                 <textarea
//                                   name={field.field_name}
//                                   className="form-control"
//                                   value={formData[field.field_name] || ""}
//                                   required={field.is_required}
//                                   placeholder={field.placeholder}
//                                   onChange={(e) => {
//                                     setFormData((prev) => ({
//                                       ...prev,
//                                       [field.field_name]: e.target.value,
//                                     }));
//                                     clearFieldError(field.field_name);
//                                   }}
//                                 />
//                               </div>
//                             )}

//                             {/* Date field */}
//                             {field.field_type === "date" && (
//                               <div className="input-group">
//                                 <DatePicker
//                                   selected={
//                                     dateValues[field.field_label] || null
//                                   }
//                                   onChange={(date) => {
//                                     setDateValues((prev) => {
//                                       const updated = {
//                                         ...prev,
//                                         [field.field_label]: date,
//                                       };

//                                       // Handle date dependencies
//                                       if (
//                                         field.field_label ===
//                                         "Start Date & Time"
//                                       ) {
//                                         if (
//                                           updated["End Date & Time"] &&
//                                           date > updated["End Date & Time"]
//                                         ) {
//                                           updated["End Date & Time"] = null;
//                                         }
//                                       }

//                                       if (
//                                         field.field_label === "Work Time From"
//                                       ) {
//                                         if (
//                                           updated["Work Time To"] &&
//                                           date > updated["Work Time To"]
//                                         ) {
//                                           updated["Work Time To"] = null;
//                                         }
//                                       }

//                                       return updated;
//                                     });

//                                     clearFieldError(field.field_label);
//                                   }}
//                                   showTimeSelect
//                                   dateFormat="dd/MM/yyyy hh:mm a"
//                                   className="form-control"
//                                   placeholderText={
//                                     field.placeholder || "Select date"
//                                   }
//                                   minDate={
//                                     field.field_label === "End Date & Time"
//                                       ? dateValues["Start Date & Time"] ||
//                                         new Date()
//                                       : field.field_label === "Work Time To"
//                                       ? dateValues["Work Time From"] ||
//                                         new Date()
//                                       : new Date()
//                                   }
//                                   minTime={
//                                     field.field_label === "End Date & Time" &&
//                                     dateValues["Start Date & Time"] &&
//                                     dateValues["End Date & Time"] &&
//                                     new Date(
//                                       dateValues["Start Date & Time"]
//                                     ).toDateString() ===
//                                       new Date(
//                                         dateValues["End Date & Time"]
//                                       ).toDateString()
//                                       ? new Date(
//                                           dateValues["Start Date & Time"]
//                                         )
//                                       : field.field_label === "Work Time To" &&
//                                         dateValues["Work Time From"] &&
//                                         dateValues["Work Time To"] &&
//                                         new Date(
//                                           dateValues["Work Time From"]
//                                         ).toDateString() ===
//                                           new Date(
//                                             dateValues["Work Time To"]
//                                           ).toDateString()
//                                       ? new Date(dateValues["Work Time From"])
//                                       : setHours(setMinutes(new Date(), 0), 0)
//                                   }
//                                   maxTime={setHours(
//                                     setMinutes(new Date(), 59),
//                                     23
//                                   )}
//                                   required={field.is_required}
//                                 />
//                               </div>
//                             )}
//                           </>
//                         )}

//                         {errors[field.field_name] && (
//                           <div className="error-message">
//                             {errors[field.field_name]}
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//               </div>
//             </div>
//           </form>
//         </div>
//         <div className="footer">
//           <div className="button-group_div">
//             <div className="button-subgroup">
//               <button
//                 className="data-form-save-button"
//                 type="save"
//                 onClick={handleSaveClick}
//                 disabled={isLoading}
//               >
//                 {isLoading ? "Saving..." : "Save & Next"}
//               </button>
//             </div>
//             <div className="button-subgroup">
//               <button
//                 className="permitdata-form-cancel-button"
//                 onClick={handleCancelClick}
//               >
//                 Cancel
//               </button>
//             </div>

//             <div className="button-subgroup">
//               <button
//                 className="data-form-reject-button"
//                 onClick={handleRejectClick}
//               >
//                 Reject
//               </button>
//             </div>
//           </div>
//         </div>

//         {isPopupOpen && (
//           <div className="permit-popup-model">
//             <div className="form-permit-popup-content">
//               <div className="reminder-popup-model-header">
//                 <div className="reminder-popup-model-content-header">
//                   <div className="reminder-popup-model-content-header-left-part">
//                     Reject Permit
//                   </div>
//                   <div className="reminder-popup-model-content-header-right-part"></div>
//                 </div>
//                 <div className="permit-popup-new-form">
//                   <form className="form-permit-popup-detail">
//                     <div className="new-data-form">
//                       <div className="new-form-group email-filed">
//                         <label htmlFor="reason">
//                           Reason for rejection{" "}
//                           <span className="text-danger">*</span>
//                         </label>
//                         <div className="input-group">
//                           <textarea
//                             id="reason"
//                             name="reason"
//                             placeholder="Enter reason"
//                             value={reason}
//                             onChange={handleReasonChange}
//                             rows="4"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//                 <div className="footers">
//                   <div className="form-button-group">
//                     <div>
//                       <button
//                         className="form-reject-button"
//                         type="button"
//                         onClick={handleSaveRejectClick}
//                         disabled={isLoading}
//                       >
//                         Reject
//                       </button>

//                       <button
//                         className="person-user-cancel-button"
//                         onClick={closePopup}
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                     <div></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px", marginLeft: "20px" }}
//       >
//         <MuiAlert onClose={handleSnackbarClose} severity={severity}>
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default Form1;


import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes } from "date-fns";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import "./Form.css";

function Form1({
  isSidebarExpanded,
  permit_id,
  permit_type_id,
  fetchComplitionSatusData,
}) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const { id } = useParams();
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [permitType, setPermitType] = useState([]);
  const [selectedPermitType, setSelectedPermitType] = useState(null);
  const [tagOptions, setTagOptions] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [workPermitName, setWorkPermitName] = useState("");
  const [workPermitId, setWorkPermitId] = useState("");
  const [equipmentDetails, setEquipmentDetails] = useState([]);
  const [work_id, setWork_id] = useState("");
  const [dateValues, setDateValues] = useState({});
  const [dynamicSubFields, setDynamicSubFields] = useState([]);
  const [fields, setFields] = useState([]);
  const [dynamicApiEndpoint, setDynamicApiEndpoint] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  // Tracks saved issued_to so dependent fields can be restored on load
  const [savedIssuedTo, setSavedIssuedTo] = useState("");

  const [formData, setFormData] = useState({
    section: "",
    department_id: "",
    form_id: "",
    area: "",
    equipment_no: "",
    issued_to: "",
    work_description: "",
    contractor: "",
    unit: "",
    location: "",
    facility_location: "",
    work_location: "",
    valid_from: "",
    valid_to: "",
    receiver_name: "",
    permit_type_id: "",
    permit_id: "",
    department: "",
    no_of_men: "",
    excavation_depth: "",
    excavation_length: "",
    excavation_width: "",
    work_type_list: [],
    work_type: [],
    performing_agency: "",
    related_permit_no: "",
    work_time_from: "",
    work_time_to: "",
  });

  // ============================================
  // WORK TYPE CHECKBOX MUTUAL EXCLUSION
  // Excavation alone ✓ | Road Cutting alone ✓ | Excavation+Road Cutting ✓
  // Road Closure must be selected alone
  // ============================================
  const normalizeWorkTypes = (permit = {}) => {
    const rawWorkTypeList = Array.isArray(permit.work_type_list)
      ? permit.work_type_list
      : [];

    if (rawWorkTypeList.length > 0) {
      return rawWorkTypeList
        .flatMap((value) =>
          typeof value === "string" ? value.split(",") : [value]
        )
        .map((value) => (typeof value === "string" ? value.trim() : ""))
        .filter(Boolean);
    }

    const rawWorkType = permit.work_type;

    if (Array.isArray(rawWorkType)) {
      return rawWorkType
        .flatMap((value) =>
          typeof value === "string" ? value.split(",") : [value]
        )
        .map((value) => (typeof value === "string" ? value.trim() : ""))
        .filter(Boolean);
    }

    if (typeof rawWorkType === "string") {
      return rawWorkType
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);
    }

    return [];
  };

  const handleWorkTypeChange = (fieldName, option, checked) => {
    setFormData((prev) => {
      const current = Array.isArray(prev[fieldName]) ? prev[fieldName] : [];
      const syncWorkTypeState = (nextValues) => ({
        ...prev,
        [fieldName]: nextValues,
        ...(fieldName === "work_type" ? { work_type_list: nextValues } : {}),
      });

      if (!checked) {
        return syncWorkTypeState(current.filter((v) => v !== option));
      }

      if (option === "Road Closure") {
        return syncWorkTypeState(["Road Closure"]);
      }

      if (current.includes("Road Closure")) {
        showSnackbar(
          "Road Closure must be selected alone. Please deselect it first."
        );
        return prev;
      }

      return syncWorkTypeState([...current, option]);
    });
    clearFieldError(fieldName);
  };

  const getWorkTypeDisabled = (fieldName, option) => {
    const current = Array.isArray(formData[fieldName])
      ? formData[fieldName]
      : [];
    if (option === "Road Closure") {
      return current.includes("Excavation") || current.includes("Road Cutting");
    }
    if (option === "Excavation" || option === "Road Cutting") {
      return current.includes("Road Closure");
    }
    return false;
  };

  // ============================================
  // VALIDATION
  // ============================================
  const validateRequiredFields = () => {
    const errors = {};

    if (!selectedPermitType?.value && !formData.permit_type_id) {
      errors.selectedPermitType = "Permit Type is required";
    }

    fields.forEach((field) => {
      if (Number(field.is_required) === 1) {
        const fieldName = field.field_name;
        const fieldLabel = field.field_label;

        if (field.field_type === "dropdown") {
          if (field.is_multiple) {
            if (!selectedOptions[field.id]?.length) {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          } else {
            const hasValueInFormData =
              formData[fieldName] && formData[fieldName] !== "";
            const hasValueInSelectedOptions = selectedOptions[field.id]?.value;
            if (!hasValueInFormData && !hasValueInSelectedOptions) {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          }
        } else if (field.field_type === "date") {
          if (!dateValues[fieldLabel]) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else if (field.field_type === "checkbox") {
          const checkboxValues = formData[fieldName];
          if (
            !checkboxValues ||
            (Array.isArray(checkboxValues) && checkboxValues.length === 0)
          ) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else {
          const value = formData[fieldName];
          if (!value || (typeof value === "string" && !value.trim())) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        }
      }
    });

    dynamicSubFields.forEach((subField) => {
      if (Number(subField.is_required) === 1) {
        const fieldName = subField.field_name;
        const fieldLabel = subField.field_label;

        if (subField.field_type === "dropdown") {
          if (fieldName === "department_name") {
            if (!formData.department_id || formData.department_id === "") {
              errors.department_id = `${fieldLabel} is required`;
            }
          } else {
            if (!formData[fieldName] || formData[fieldName] === "") {
              errors[fieldName] = `${fieldLabel} is required`;
            }
          }
        } else if (subField.field_type === "date") {
          if (!dateValues[fieldLabel]) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else if (subField.field_type === "checkbox") {
          const checkboxValues = formData[fieldName];
          if (
            !checkboxValues ||
            (Array.isArray(checkboxValues) && checkboxValues.length === 0)
          ) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        } else {
          const value = formData[fieldName];
          if (!value || (typeof value === "string" && !value.trim())) {
            errors[fieldName] = `${fieldLabel} is required`;
          }
        }
      }
    });

    const startDateField = fields.find(
      (f) => f.field_label === "Start Date & Time"
    );
    const endDateField = fields.find(
      (f) => f.field_label === "End Date & Time"
    );
    if (startDateField && endDateField) {
      const startDate = dateValues[startDateField.field_label];
      const endDate = dateValues[endDateField.field_label];
      if (startDate && endDate && startDate >= endDate) {
        errors[endDateField.field_name] = "End date must be after start date";
      }
    }

    const workTimeFromField = fields.find(
      (f) => f.field_label === "Work Time From"
    );
    const workTimeToField = fields.find(
      (f) => f.field_label === "Work Time To"
    );
    if (workTimeFromField && workTimeToField) {
      const workTimeFrom = dateValues[workTimeFromField.field_label];
      const workTimeTo = dateValues[workTimeToField.field_label];
      if (workTimeFrom && workTimeTo && workTimeFrom >= workTimeTo) {
        errors[workTimeToField.field_name] =
          "Work time to must be after work time from";
      }
    }

    return errors;
  };

  // ============================================
  // PAYLOAD BUILDER
  // ============================================
  const buildDynamicPayload = () => {
    const payload = {
      permit_type_id: formData.permit_type_id,
      work_id: work_id || "",
    };

    fields.forEach((field) => {
      const fieldName = field.field_name;
      const fieldLabel = field.field_label;

      switch (field.field_type) {
        case "dropdown":
          if (field.is_multiple) {
            payload[fieldName] = selectedOptions[field.id]
              ? selectedOptions[field.id].map((item) => item.value)
              : [];
          } else {
            payload[fieldName] =
              formData[fieldName] || selectedOptions[field.id]?.value || "";
          }
          break;
        case "date":
          if (dateValues[fieldLabel]) {
            const dt = new Date(dateValues[fieldLabel]);
            payload[fieldName] = `${dt.getFullYear()}-${String(
              dt.getMonth() + 1
            ).padStart(2, "0")}-${String(dt.getDate()).padStart(
              2,
              "0"
            )} ${String(dt.getHours()).padStart(2, "0")}:${String(
              dt.getMinutes()
            ).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
          } else {
            payload[fieldName] = null;
          }
          break;
        case "checkbox":
          const cv = formData[fieldName];
          payload[fieldName] = Array.isArray(cv) ? cv : cv ? [cv] : [];
          break;
        case "number":
          const nv = formData[fieldName];
          payload[fieldName] = nv && nv !== "" ? Number(nv) : null;
          break;
        default:
          const tv = formData[fieldName];
          payload[fieldName] =
            tv && typeof tv === "string" ? tv.trim() : tv || "";
      }
    });

    dynamicSubFields.forEach((subField) => {
      const fieldName = subField.field_name;
      const fieldLabel = subField.field_label;

      switch (subField.field_type) {
        case "dropdown":
          if (fieldName === "department_name") {
            payload["department_id"] = formData.department_id || "";
          } else {
            payload[fieldName] = formData[fieldName] || "";
          }
          break;
        case "date":
          if (dateValues[fieldLabel]) {
            const dt = new Date(dateValues[fieldLabel]);
            payload[fieldName] = `${dt.getFullYear()}-${String(
              dt.getMonth() + 1
            ).padStart(2, "0")}-${String(dt.getDate()).padStart(
              2,
              "0"
            )} ${String(dt.getHours()).padStart(2, "0")}:${String(
              dt.getMinutes()
            ).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
          } else {
            payload[fieldName] = null;
          }
          break;
        case "checkbox":
          const cv = formData[fieldName];
          payload[fieldName] = Array.isArray(cv) ? cv : cv ? [cv] : [];
          break;
        case "number":
          const nv = formData[fieldName];
          payload[fieldName] = nv && nv !== "" ? Number(nv) : null;
          break;
        default:
          const tv = formData[fieldName];
          payload[fieldName] =
            tv && typeof tv === "string" ? tv.trim() : tv || "";
      }
    });

    return payload;
  };

  // ============================================
  // SAVE HANDLER
  // ============================================
  const handleSaveClick = async () => {
    try {
      setErrors({});
      const validationErrors = validateRequiredFields();

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setSeverity("error");
        showSnackbar("Please fill all required fields");
        const firstErrorField = Object.keys(validationErrors)[0];
        const errorElement = document.querySelector(
          `[name="${firstErrorField}"]`
        );
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      const payload = buildDynamicPayload();
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.put(
        `${API_URL}/api/update_permit_work_details`,
        payload,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit details updated successfully.");
        {
          permit_type_id === "e32d9e81-a68c-11f0-81e8-9c2dcdaf01ba"
            ? setTimeout(() => {
                navigate(
                  `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Departments`
                );
              }, 1000)
            : setTimeout(() => {
                navigate(
                  `/cold-work-permit-form/${permit_id}/${permit_type_id}?tab=Checklist Items`
                );
              }, 1000);
        }
      } else {
        throw new Error(
          response.data.message || "Failed to update permit details."
        );
      }
    } catch (error) {
      console.error("Error saving permit details:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          error.message ||
          "An error occurred while saving permit details."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSaveRejectClick = async () => {
    const payload = {
      permit_id: permit_id,
      request_type: "New",
      reason: reason,
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      const response = await axios.post(
        `${API_URL}/api/reject_permit`,
        payload,
        { headers: { Authorization: authKey } }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        closePopup();
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelClick = () => navigate("/cold-work-permit");
  const handleRejectClick = () => setIsPopupOpen(true);

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const clearFieldError = (fieldName) => {
    if (errors[fieldName] || errors.department_id) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];
        if (fieldName === "department_name" && newErrors.department_id) {
          delete newErrors.department_id;
        }
        return newErrors;
      });
    }
  };

  // ============================================
  // FETCH DEPARTMENTS
  // ============================================
  const fetchDepartment = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_departments`, {
        headers: { Authorization: authKey },
      });
      const options = response.data.map((department) => ({
        label: department.DepartmentName,
        value: department.ID,
      }));
      setDepartments(options);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  // ============================================
  // FETCH TAG OPTIONS
  // ============================================
  const fetchOptions = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_equipment_tag_no`, {
        headers: { Authorization: authKey },
      });
      const optionsData = response.data.Items.map((item) => ({
        value: item.ID,
        label: `${item.TagNo}`,
      }));
      setTagOptions(optionsData);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  // ============================================
  // FETCH PERMIT TYPES
  // ============================================
  const fetchPermitType = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/get_work_permit_types`, {
        headers: { Authorization: authKey },
      });
      const permitTypeOptions = response.data.work_permit_types.map((p) => ({
        value: p.id,
        label: p.work_permit_name,
      }));
      setPermitType(permitTypeOptions);
    } catch (error) {
      console.error("Error fetching permit types:", error);
    }
  };

  // ============================================
  // FETCH DEPENDENT FIELDS
  // Reusable — called on initial load and on manual issued_to change
  // ============================================
  const fetchDependentFields = async ({
    permitTypeId,
    issuedToFieldId,
    issuedToValue,
  }) => {
    if (!issuedToValue || !issuedToFieldId) return;

    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/dependent_fields`, {
        headers: { Authorization: authKey },
        params: {
          permit_type_id: permitTypeId,
          controller_field_id: issuedToFieldId,
          controller_value: issuedToValue,
        },
      });

      let fetchedSubFields = response.data.fields || [];

      for (const subField of fetchedSubFields) {
        if (subField.options_source === "api" && subField.api_endpoint) {
          try {
            const subOptionsRes = await axios.get(
              `${API_URL}/${subField.api_endpoint}`,
              { headers: { Authorization: authKey } }
            );
            subField.options = subOptionsRes.data || [];
          } catch (e) {
            console.error(
              `Error fetching sub-field options for ${subField.field_label}:`,
              e
            );
          }
        }
      }

      setDynamicSubFields(fetchedSubFields);
    } catch (error) {
      console.error("Error fetching dependent fields:", error);
      setDynamicSubFields([]);
    }
  };

  // ============================================
  // HANDLE PERMIT TYPE CHANGE
  // After loading fields, restores dependent sub-fields
  // for the saved issued_to value
  // ============================================
  const handlePermitTypeChange = async (selectedOption) => {
    setSelectedPermitType(selectedOption);
    if (!selectedOption) return;

    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(
        `${API_URL}/api/get_permit_fields/${selectedOption.value}`,
        { headers: { Authorization: authKey } }
      );

      if (response.status === 200) {
        const fetchedFields = response.data.fields;
        setFields(fetchedFields);

        const dropdownFields = fetchedFields.filter(
          (field) => field.field_type === "dropdown" && field.api_endpoint
        );

        const optionsData = {};
        await Promise.all(
          dropdownFields.map(async (field) => {
            try {
              const dropdownResponse = await axios.get(
                `${API_URL}/${field.api_endpoint}`,
                { headers: { Authorization: authKey } }
              );
              const responseData = dropdownResponse.data;
              optionsData[field.id] = Array.isArray(responseData)
                ? responseData.map((item) => ({
                    value: item.ID,
                    label:
                      item.DepartmentName ||
                      item.TagNo ||
                      item.Category ||
                      "Unknown",
                  }))
                : responseData.Items?.map((item) => ({
                    value: item.ID,
                    label: item.TagNo || item.Category || "Unknown",
                  })) || [];
            } catch (error) {
              console.error(
                `Error fetching options for ${field.field_label}:`,
                error
              );
            }
          })
        );

        setDropdownOptions(optionsData);

        // Restore dependent sub-fields for the saved issued_to value
        const issuedToField = fetchedFields.find(
          (f) => f.field_name === "issued_to"
        );
        if (issuedToField && savedIssuedTo) {
          await fetchDependentFields({
            permitTypeId: selectedOption.value,
            issuedToFieldId: issuedToField.id,
            issuedToValue: savedIssuedTo,
          });
        }
      }

      // Fetch the dynamic endpoint
      const endpointResponse = await axios.get(
        `${API_URL}/api/get_permit_api_endpoints/${selectedOption.value}`,
        { headers: { Authorization: authKey } }
      );
      if (
        endpointResponse.status === 200 &&
        endpointResponse.data.endpoints.length > 0
      ) {
        const postEndpoint = endpointResponse.data.endpoints.find(
          (e) => e.method === "POST"
        );
        if (postEndpoint) {
          setDynamicApiEndpoint(postEndpoint.api_endpoint);
        }
      }
    } catch (error) {
      console.error("Error fetching permit fields:", error);
    }
  };

  // ============================================
  // LOAD PERMIT DETAILS ON MOUNT
  // ============================================
  useEffect(() => {
    const getPermitDetails = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(
          `${API_URL}/api/get_permit_work_details/${permit_id}`,
          { headers: { Authorization: authKey } }
        );

        const permit = response.data.permit_details[0];

        setWorkPermitName(permit?.work_permit_name);
        setWorkPermitId(permit?.permit_type_id);
        setWork_id(permit?.work_id);
        setEquipmentDetails(permit?.equipment_details || []);

        const issuedToValue = permit.issued_to?.value || "";
        setSavedIssuedTo(issuedToValue);

        const dependentFieldValues = {};
        const dependentFieldsFromPermit =
          permit.issued_to?.dependent_fields || [];
        dependentFieldsFromPermit.forEach((dep) => {
          dependentFieldValues[dep.field_name] = dep.value;
        });

        // Normalize work_type — ensure it's always an array
        const workTypeArray = normalizeWorkTypes(permit);

        setFormData((prev) => ({
          ...prev,
          permit_type_id: permit.permit_type_id,
          issued_to: issuedToValue,
          ...dependentFieldValues,
          department: permit.department_name,
          department_id: permit?.department_id || "",
          receiver_name: permit.receiver_name,
          area: permit.area || "",
          unit: permit.unit || "",
          section: permit?.section || "",
          location: permit?.facility_location || "",
          facility_location: permit?.facility_location || "",
          work_location: permit?.work_location || "",
          work_description: permit.work_description || "",
          contractor: permit?.contractor || "",
          no_of_men: permit.no_of_men || "",
          excavation_depth: permit.excavation_depth || "",
          excavation_length: permit.excavation_length || "",
          excavation_width: permit.excavation_width || "",
          work_type_list: workTypeArray,
          work_type: workTypeArray,
          performing_agency: permit.performing_agency || "",
          related_permit_no: permit.related_permit_no || "",
        }));

        const formatDate = (dateString) => {
          if (!dateString) return null;
          const date = new Date(dateString);
          date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
          return date;
        };

        setDateValues({
          "Start Date & Time": formatDate(permit.valid_from),
          "End Date & Time": formatDate(permit.valid_to),
          "Work Start (From Date & Time)": formatDate(permit.work_time_from),
          "Work End (To Date & Time)": formatDate(permit.work_time_to),
        });

        setIsDataLoaded(true);
      } catch (error) {
        console.error("Failed to load permit details", error);
        setSeverity("error");
        showSnackbar("Failed to load permit details");
      }
    };

    if (permit_id) {
      getPermitDetails();
    }
  }, [permit_id]);

  // ============================================
  // MAP EQUIPMENT DETAILS TO SELECTED OPTIONS
  // ============================================
  useEffect(() => {
    if (fields?.length && equipmentDetails?.length && isDataLoaded) {
      const equipmentField = fields.find(
        (f) => f.field_name === "equipment_ids"
      );
      if (equipmentField) {
        const selectedEquipment = equipmentDetails.map((eq) => ({
          value: eq.equipment_id,
          label: eq.TagNo || eq.equipment_no || "",
        }));
        setSelectedOptions((prev) => ({
          ...prev,
          [equipmentField.id]: selectedEquipment,
        }));
        if (!dropdownOptions[equipmentField.id]) {
          setDropdownOptions((prev) => ({
            ...prev,
            [equipmentField.id]: selectedEquipment,
          }));
        }
      }
    }
  }, [fields, equipmentDetails, isDataLoaded]);

  // ============================================
  // INITIALIZE PERMIT TYPE FIELDS ON LOAD
  // savedIssuedTo in deps ensures dependent fields are fetched
  // even if it resolves after workPermitId
  // ============================================
  useEffect(() => {
    if (formData.permit_type_id && workPermitId) {
      const selectedOption = {
        value: workPermitId,
        label: workPermitName,
      };
      handlePermitTypeChange(selectedOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.permit_type_id, workPermitId, savedIssuedTo]);

  useEffect(() => {
    fetchDepartment();
    fetchPermitType();
    fetchOptions();
  }, []);

  return (
    <>
      <div className="data-form-content">
        <div className="data-form-header">
          <div className="data-form-header-content">
            <PageBackTitle className="data-form-heading-content-left-side">Work Permit Request</PageBackTitle>
            <div className="data-form-heading-content-right-side"></div>
          </div>
        </div>
        <div className="header-separator"></div>
        <div className="data-form-body">
          <form className="form-detail">
            <div className="new-data-form">
              {/* Permit Type */}
              <div className="form-group-select">
                <label htmlFor="form_type">
                  Permit Type<span className="text-danger">*</span>
                </label>
                <Select
                  id="form_type"
                  options={permitType}
                  value={permitType.find(
                    (option) => option.value === formData.permit_type_id
                  )}
                  onChange={handlePermitTypeChange}
                  placeholder="Select permit type"
                  isDisabled={true}
                />
                {errors.selectedPermitType && (
                  <div className="error-message">
                    {errors.selectedPermitType}
                  </div>
                )}
              </div>

              {/* Dynamic Fields */}
              <div className="permit-fields-container">
                {fields?.length > 0 &&
                  fields.map((field) => {
                    const isIssuedToField = field.field_name === "issued_to";

                    return (
                      <div key={field.id} className="form-group">
                        <label>
                          {field.field_label}
                          {Number(field.is_required) === 1 && (
                            <span className="text-danger">*</span>
                          )}
                        </label>

                        {isIssuedToField ? (
                          <div className="wp-dflex-div">
                            <div className="">
                              <Select
                                className="full-width-select-wp"
                                options={field.options.map((opt) => ({
                                  label: opt,
                                  value: opt,
                                }))}
                                value={
                                  formData.issued_to
                                    ? {
                                        value: formData.issued_to,
                                        label: formData.issued_to,
                                      }
                                    : null
                                }
                                onChange={async (selected) => {
                                  const value = selected ? selected.value : "";
                                  setFormData((prev) => ({
                                    ...prev,
                                    issued_to: value,
                                    department_id: "",
                                  }));
                                  setErrors((prevErrors) => {
                                    const newErrors = { ...prevErrors };
                                    delete newErrors[field.field_name];
                                    delete newErrors.issued_to;
                                    return newErrors;
                                  });
                                  if (value) {
                                    await fetchDependentFields({
                                      permitTypeId: formData.permit_type_id,
                                      issuedToFieldId: field.id,
                                      issuedToValue: value,
                                    });
                                  } else {
                                    setDynamicSubFields([]);
                                  }
                                }}
                                placeholder="Select issued to"
                                isClearable
                              />
                            </div>

                            <div style={{ marginBottom: "0px" }}>
                              {dynamicSubFields.map((subField) => (
                                <div
                                  key={subField.id}
                                  className={
                                    subField.field_type === "dropdown"
                                      ? "form-group-select"
                                      : "form-group"
                                  }
                                >
                                  <label>
                                    {subField.field_label}
                                    {Number(subField.is_required) === 1 && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </label>

                                  {subField.field_type === "dropdown" && (
                                    <Select
                                      className="full-width-select-wp"
                                      options={(subField.options?.length > 0
                                        ? subField.options
                                        : departments
                                      ).map((opt) => ({
                                        value: opt?.ID || opt?.value,
                                        label:
                                          opt?.DepartmentName ||
                                          opt?.Name ||
                                          opt?.label ||
                                          "",
                                      }))}
                                      value={(() => {
                                        const isDepartmentField =
                                          subField.field_name ===
                                          "department_name";
                                        const storedValue = isDepartmentField
                                          ? formData.department_id
                                          : formData[subField.field_name];

                                        if (!storedValue) return null;

                                        const allOpts = (
                                          subField.options?.length > 0
                                            ? subField.options
                                            : departments
                                        ).map((opt) => ({
                                          value: opt?.ID || opt?.value,
                                          label:
                                            opt?.DepartmentName ||
                                            opt?.Name ||
                                            opt?.label ||
                                            "",
                                        }));

                                        const matched = allOpts.find(
                                          (o) =>
                                            String(o.value) ===
                                            String(storedValue)
                                        );

                                        return matched
                                          ? matched
                                          : {
                                              value: storedValue,
                                              label:
                                                formData[
                                                  subField.field_label
                                                ] ||
                                                formData.department ||
                                                "",
                                            };
                                      })()}
                                      onChange={(selected) => {
                                        const selectedId =
                                          selected?.value || "";
                                        const selectedLabel =
                                          selected?.label || "";
                                        setFormData((prev) => {
                                          const updates = {
                                            ...prev,
                                            [subField.field_label]:
                                              selectedLabel,
                                            [subField.field_name]: selectedId,
                                          };
                                          if (
                                            subField.field_name ===
                                            "department_name"
                                          ) {
                                            updates.department_id = selectedId;
                                            updates.department = selectedLabel;
                                          }
                                          return updates;
                                        });
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors };
                                          delete newErrors[subField.field_name];
                                          if (
                                            subField.field_name ===
                                            "department_name"
                                          ) {
                                            delete newErrors.department_id;
                                          }
                                          return newErrors;
                                        });
                                      }}
                                      placeholder={
                                        subField.placeholder ||
                                        `Select ${subField.field_label}`
                                      }
                                      isClearable
                                    />
                                  )}

                                  {subField.field_type === "text" && (
                                    <div className="input-group full-width-input-wp">
                                      <input
                                        className="full-width-input-wp"
                                        type="text"
                                        name={subField.field_name}
                                        value={
                                          formData[subField.field_name] || ""
                                        }
                                        onChange={(e) => {
                                          setFormData((prev) => ({
                                            ...prev,
                                            [subField.field_name]:
                                              e.target.value,
                                          }));
                                          clearFieldError(subField.field_name);
                                        }}
                                        placeholder={subField.placeholder || ""}
                                      />
                                    </div>
                                  )}

                                  {(errors[subField.field_name] ||
                                    (subField.field_name ===
                                      "department_name" &&
                                      errors.department_id)) && (
                                    <div className="error-message">
                                      {errors[subField.field_name] ||
                                        errors.department_id}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* Dropdown */}
                            {field.field_type === "dropdown" && (
                              <div className="input-group form-group-tag-no">
                                <Select
                                  id={field.field_label}
                                  isMulti={field.is_multiple}
                                  options={
                                    field.options_source === "api"
                                      ? dropdownOptions[field.id] || []
                                      : field.options.map((opt) => ({
                                          value: opt,
                                          label: opt,
                                        }))
                                  }
                                  value={
                                    selectedOptions[field.id] ||
                                    (field.is_multiple ? [] : null)
                                  }
                                  onMenuOpen={async () => {
                                    if (
                                      field.options_source === "api" &&
                                      !dropdownOptions[field.id]
                                    ) {
                                      try {
                                        const authKey =
                                          localStorage.getItem("authKey");
                                        const response = await axios.get(
                                          `${API_URL}/${field.api_endpoint}`,
                                          {
                                            headers: {
                                              Authorization: authKey,
                                            },
                                          }
                                        );
                                        const fetchedOptions =
                                          response.data.options || [];
                                        setDropdownOptions((prev) => ({
                                          ...prev,
                                          [field.id]: fetchedOptions.map(
                                            (opt) => ({
                                              value: opt,
                                              label: opt,
                                            })
                                          ),
                                        }));
                                      } catch (err) {
                                        console.error(
                                          "Failed to load dynamic options:",
                                          err
                                        );
                                      }
                                    }
                                  }}
                                  onChange={(selected) => {
                                    setSelectedOptions((prev) => ({
                                      ...prev,
                                      [field.id]: selected,
                                    }));
                                    clearFieldError(field.field_name);
                                    if (field.field_name === "equipment_ids") {
                                      setFormData((prev) => ({
                                        ...prev,
                                        equipment_ids: selected
                                          ? selected.map((tag) => tag.value)
                                          : [],
                                      }));
                                    }
                                  }}
                                  isSearchable
                                  isClearable={!field.is_multiple}
                                  placeholder={
                                    field.placeholder || "Select option"
                                  }
                                  styles={{
                                    container: (base) => ({
                                      ...base,
                                      width: "100%",
                                    }),
                                  }}
                                />
                                {Boolean(field.is_multiple) &&
                                  selectedOptions[field.id]?.length > 0 && (
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      flexWrap="wrap"
                                      sx={{ mt: 1 }}
                                      className="chip-wrapper"
                                    >
                                      {selectedOptions[field.id].map((tag) => (
                                        <Chip
                                          key={tag.value}
                                          label={tag.label}
                                          onDelete={() => {
                                            const updated = selectedOptions[
                                              field.id
                                            ].filter(
                                              (item) => item.value !== tag.value
                                            );
                                            setSelectedOptions((prev) => ({
                                              ...prev,
                                              [field.id]: updated,
                                            }));
                                            if (
                                              field.field_name === "equipment_ids"
                                            ) {
                                              setFormData((prev) => ({
                                                ...prev,
                                                equipment_ids: updated.map(
                                                  (item) => item.value
                                                ),
                                              }));
                                            }
                                          }}
                                          color="primary"
                                          variant="outlined"
                                          sx={{ mb: 1 }}
                                        />
                                      ))}
                                    </Stack>
                                  )}
                              </div>
                            )}

                            {/* Text */}
                            {field.field_type === "text" && (
                              <div className="input-group">
                                <input
                                  type="text"
                                  name={field.field_name}
                                  className="form-control"
                                  value={formData[field.field_name] || ""}
                                  required={field.is_required}
                                  placeholder={field.placeholder}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      [field.field_name]: e.target.value,
                                    }));
                                    clearFieldError(field.field_name);
                                  }}
                                />
                              </div>
                            )}

                            {/* Checkbox — with mutual exclusion */}
                            {field.field_type === "checkbox" && (
                              <div>
                                <div
                                  className={`permit_checkbox_group${
                                    field.field_name === "work_type"
                                      ? " permit-work-type-options"
                                      : ""
                                  }`}
                                >
                                  {[
                                    "Excavation",
                                    "Road Cutting",
                                    "Road Closure",
                                  ].map((option) => {
                                    const isDisabled = getWorkTypeDisabled(
                                      field.field_name,
                                      option
                                    );
                                    return (
                                      <label
                                        key={option}
                                        className="permit_checkbox-item"
                                        style={
                                          isDisabled
                                            ? {
                                                opacity: 0.5,
                                                cursor: "not-allowed",
                                              }
                                            : {}
                                        }
                                      >
                                        <div className="checkbox_input">
                                          <input
                                            type="checkbox"
                                            name={field.field_name}
                                            value={option}
                                            className="permit_small-checkbox"
                                            checked={
                                              Array.isArray(
                                                formData[field.field_name]
                                              )
                                                ? formData[
                                                    field.field_name
                                                  ].includes(option)
                                                : false
                                            }
                                            disabled={isDisabled}
                                            required={
                                              Number(field.is_required) === 1
                                            }
                                            onChange={(e) =>
                                              handleWorkTypeChange(
                                                field.field_name,
                                                option,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </div>
                                        <div className="checkbox_option">
                                          {option}
                                        </div>
                                      </label>
                                    );
                                  })}
                                </div>
                                <small
                                  style={{ color: "#666", fontSize: "12px" }}
                                >
                                  Excavation alone ✓ &nbsp;|&nbsp; Road Cutting
                                  alone ✓ &nbsp;|&nbsp; Excavation + Road
                                  Cutting together ✓ &nbsp;|&nbsp; Road Closure
                                  must be selected alone ✓
                                </small>
                              </div>
                            )}

                            {/* Number */}
                            {field.field_type === "number" && (
                              <div className="input-group">
                                <input
                                  type="number"
                                  name={field.field_name}
                                  className="form-control"
                                  value={formData[field.field_name] || ""}
                                  required={field.is_required}
                                  placeholder={field.placeholder}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      [field.field_name]: e.target.value,
                                    }));
                                    clearFieldError(field.field_name);
                                  }}
                                />
                              </div>
                            )}

                            {/* Textarea */}
                            {field.field_type === "textarea" && (
                              <div className="input-group">
                                <textarea
                                  name={field.field_name}
                                  className="form-control"
                                  value={formData[field.field_name] || ""}
                                  required={field.is_required}
                                  placeholder={field.placeholder}
                                  onChange={(e) => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      [field.field_name]: e.target.value,
                                    }));
                                    clearFieldError(field.field_name);
                                  }}
                                />
                              </div>
                            )}

                            {/* Date */}
                            {field.field_type === "date" && (
                              <div className="input-group">
                                <DatePicker
                                  selected={
                                    dateValues[field.field_label] || null
                                  }
                                  onChange={(date) => {
                                    setDateValues((prev) => {
                                      const updated = {
                                        ...prev,
                                        [field.field_label]: date,
                                      };
                                      if (
                                        field.field_label === "Start Date & Time"
                                      ) {
                                        if (
                                          updated["End Date & Time"] &&
                                          date > updated["End Date & Time"]
                                        ) {
                                          updated["End Date & Time"] = null;
                                        }
                                      }
                                      if (
                                        field.field_label === "Work Time From"
                                      ) {
                                        if (
                                          updated["Work Time To"] &&
                                          date > updated["Work Time To"]
                                        ) {
                                          updated["Work Time To"] = null;
                                        }
                                      }
                                      return updated;
                                    });
                                    clearFieldError(field.field_label);
                                  }}
                                  showTimeSelect
                                  dateFormat="dd/MM/yyyy hh:mm a"
                                  className="form-control"
                                  placeholderText={
                                    field.placeholder || "Select date"
                                  }
                                  minDate={
                                    field.field_label === "End Date & Time"
                                      ? dateValues["Start Date & Time"] ||
                                        new Date()
                                      : field.field_label === "Work Time To"
                                      ? dateValues["Work Time From"] ||
                                        new Date()
                                      : new Date()
                                  }
                                  minTime={
                                    field.field_label === "End Date & Time" &&
                                    dateValues["Start Date & Time"] &&
                                    dateValues["End Date & Time"] &&
                                    new Date(
                                      dateValues["Start Date & Time"]
                                    ).toDateString() ===
                                      new Date(
                                        dateValues["End Date & Time"]
                                      ).toDateString()
                                      ? new Date(
                                          dateValues["Start Date & Time"]
                                        )
                                      : field.field_label === "Work Time To" &&
                                        dateValues["Work Time From"] &&
                                        dateValues["Work Time To"] &&
                                        new Date(
                                          dateValues["Work Time From"]
                                        ).toDateString() ===
                                          new Date(
                                            dateValues["Work Time To"]
                                          ).toDateString()
                                      ? new Date(dateValues["Work Time From"])
                                      : setHours(setMinutes(new Date(), 0), 0)
                                  }
                                  maxTime={setHours(
                                    setMinutes(new Date(), 59),
                                    23
                                  )}
                                  required={field.is_required}
                                />
                              </div>
                            )}
                          </>
                        )}

                        {errors[field.field_name] && (
                          <div className="error-message">
                            {errors[field.field_name]}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          </form>
        </div>
        <div className="footer">
          <div className="button-group_div">
            <div className="button-subgroup">
              <button
                className="data-form-save-button"
                type="save"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save & Next"}
              </button>
            </div>
            <div className="button-subgroup">
              <button
                className="permitdata-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
            <div className="button-subgroup">
              <button
                className="data-form-reject-button"
                onClick={handleRejectClick}
              >
                Reject
              </button>
            </div>
          </div>
        </div>

        {isPopupOpen && (
          <div className="permit-popup-model">
            <div className="form-permit-popup-content">
              <div className="reminder-popup-model-header">
                <div className="reminder-popup-model-content-header">
                  <div className="reminder-popup-model-content-header-left-part">
                    Reject Permit
                  </div>
                  <div className="reminder-popup-model-content-header-right-part"></div>
                </div>
                <div className="permit-popup-new-form">
                  <form className="form-permit-popup-detail">
                    <div className="new-data-form">
                      <div className="new-form-group email-filed">
                        <label htmlFor="reason">
                          Reason for rejection{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <textarea
                            id="reason"
                            name="reason"
                            placeholder="Enter reason"
                            value={reason}
                            onChange={handleReasonChange}
                            rows="4"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="footers">
                  <div className="form-button-group">
                    <div>
                      <button
                        className="form-reject-button"
                        type="button"
                        onClick={handleSaveRejectClick}
                        disabled={isLoading}
                      >
                        Reject
                      </button>
                      <button
                        className="person-user-cancel-button"
                        onClick={closePopup}
                      >
                        Cancel
                      </button>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Form1;
